import React from 'react';

/**
 * Hero superior de las subpáginas (Características, Seguridad, Precios, Contacto):
 * eyebrow mono + H1 serif con acento itálico azul + subtítulo. Mismo patrón del
 * diseño para todas las páginas internas.
 */
const PageHero2 = ({ eyebrow, title, accent, subtitle, maxWidth = 620 }) => (
  <section style={{ position: 'relative', overflow: 'clip', padding: 'clamp(48px,7vw,84px) 0 clamp(8px,2vw,20px)' }}>
    <div aria-hidden style={{ position: 'absolute', top: -120, right: -60, width: 440, height: 440, borderRadius: '50%', background: 'radial-gradient(circle,rgba(47,107,255,.22),transparent 65%)', filter: 'blur(16px)', pointerEvents: 'none' }} />
    <div style={{ position: 'relative', maxWidth: 900, margin: '0 auto', padding: '0 clamp(20px,5vw,40px)', textAlign: 'center' }}>
      <span style={{ font: "700 .8rem 'IBM Plex Mono'", letterSpacing: '.14em', textTransform: 'uppercase', color: '#6FA0FF' }}>{eyebrow}</span>
      <h1 style={{ font: "600 clamp(2.4rem,5.5vw,3.9rem)/1.04 'Source Serif 4'", letterSpacing: '-.02em', color: 'var(--heading)', margin: '14px 0 0', textWrap: 'balance' }}>
        {title}{accent ? <> <span style={{ fontStyle: 'italic', color: '#6FA0FF' }}>{accent}</span></> : null}
      </h1>
      {subtitle && (
        <p style={{ font: "400 clamp(1.05rem,1.6vw,1.25rem)/1.6 'Hanken Grotesk'", color: 'var(--body)', margin: '18px auto 0', maxWidth }}>{subtitle}</p>
      )}
    </div>
  </section>
);

export default PageHero2;
